import "../Assets/Style/RoundTextLogo.css";
import ArrowImage from "../Assets/Images/Homepage/UpArrow.png";
import AppLogo from "../Assets/Images/LogoIcon.png";
import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

const RoundAppLogo = () => {
  const text = "App Gallery • Building Intelligent Systems • ";
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // 👇 Mouse movement effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isVisible || !containerRef.current) return;

      const { innerWidth, innerHeight } = window;

      const percentX = (e.clientX - innerWidth / 2) / (innerWidth / 2);
      const percentY = (e.clientY - innerHeight / 2) / (innerHeight / 2);

      // 🔥 Move container slightly
      const moveX = percentX * 20;
      const moveY = percentY * 20;


      containerRef.current.style.transform = `
        translate(${moveX}px, ${moveY}px)
      `;
      const rotateDeg = percentX * 90; 
      textRef.current.style.transform = `rotate(${rotateDeg}deg)`;
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isVisible]);
  return (
    <Box display={{xs:'none', md:'flex'}} className="logo-container" ref={containerRef}>
      <div className="circle-text text-color-main" ref={textRef}>
        {text.split("").map((char, index) => (
          <span
            key={index}
            className="text-color-main"
            style={{
              transform: `rotate(${index * (360 / text.length)}deg)`,
            }}
          >
            {char}
          </span>
        ))}
      </div>

      <img src={AppLogo} alt="center-arrow" className="center-image" />
    </Box>
  );
};

export default RoundAppLogo;
